<template>
  <div>
    <div v-if="!busy">
      <div v-if="media.type === 'video'" class="embed-responsive embed-responsive-16by9">
        <iframe
          ref="vimeoPlayer"
          style="height: 60vh;"
          class="embed-responsive-item"
          :src="'https://player.vimeo.com/video/' + media.vimeo_number"
          frameborder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
      <p v-if="media.description" class="lead">{{ media.description }}</p>
      <div v-if="media.type === 'file'" class="my-3">
        <div v-if="mediaPreviewSupported">
          <div v-if="media.file_extension.toLowerCase() === 'pdf'">
            <PDFJSViewer :fileName="encodeURIComponent(media.url.download)" :path="path" />
          </div>
          <div v-if="isImageFile" class="d-flex justify-content-center">
            <img :src="media.url.download" alt="resonance" />
          </div>
          <div v-if="media.file_extension.toLowerCase() === 'svg'" class="d-flex justify-content-center">
            <inline-svg :src="media.url.download" style="max-width: 50% !important;"/>
          </div>
        </div>
        <div v-else class="justify-content-center text-center" style="display: grid;">
          <img src="/img/no-media-preview-icon.png" alt="" class="m-auto">
          <span class="alert alert-info mt-4">
            Online preview of .{{ media.file_extension.toLowerCase() }} format is not supported.<br>
            Please <a id="download_media" data-test="download_media" class="fw-bold pointer" @click="downloadMedia()">
            <i class="fa fa-download"></i>&nbsp;{{ $t('network.download') }}</a> to view or convert to a supported format.
          </span>
        </div>
      </div>
      <hr v-if="!inCourse" />
      <div v-if="!inCourse" class="row my-3">
        <div v-if="!inCollection" class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-items-center">
          <p v-if="$auth.auth && $auth.hasRole('super-admin')" style="margin-top: 13px; margin-bottom: 5px; color: #005f9a; font-weight: bold; cursor: pointer;"
          @click="showViewsModal = !showViewsModal">
            Stats
          </p>
        </div>
        <div v-if="!inCollection" class="col-lg-6 col-md-6 col-sm-6 col-xs-12 p-0 d-flex justify-content-end">
          <div class="mx-2">
            <div v-if="media.tags && media.tags.length > 0">
              <button class="btn btn-outline-primary" style="height: 49px; border: 2px solid;" @click="showTagsModal = !showTagsModal">Tags</button>
            </div>
            <div v-else>
              <button class="btn text-secondary btn-sm m-2 fw-bold" style="background-color: #D9D9D9;">{{ $t('no-tags') }}</button>
            </div>
          </div>
          <div class="mx-2">
            <a class="btn btn-primary" style="padding-left: 16px;" @click="showBelongsToNetworkModal = !showBelongsToNetworkModal">
              <svg width="27" height="29" viewBox="3 1 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M24.1482 11.2933C25.2965 11.2933 26.2274 10.3624 26.2274 9.21415C26.2274 8.06587 25.2965 7.13501 24.1482 7.13501C23 7.13501 22.0691 8.06587 22.0691 9.21415C22.0691 10.3624 23 11.2933 24.1482 11.2933Z"
                  fill="white"
                />
                <path
                  d="M22.4202 18.6378C22.0151 18.6378 21.6371 18.7458 21.2861 18.9889C21.3401 18.9619 21.3671 18.9349 21.4211 18.9078L19.0989 17.5038C19.2609 17.0177 19.3419 16.5317 19.3419 16.0187C19.3419 15.3976 19.2069 14.7766 18.9639 14.2095L18.9369 14.1555L21.1241 12.6974C21.6101 12.3734 21.7451 11.7254 21.4481 11.2393V11.2123C21.1241 10.7263 20.476 10.5913 19.99 10.9153L17.6948 12.4544C16.8578 11.7524 15.8047 11.3473 14.7246 11.3473C14.4006 11.3473 14.0766 11.4013 13.7526 11.4823L12.8075 9.4572C12.7535 9.5382 12.6725 9.61921 12.5915 9.70021C13.4015 8.86316 13.4015 7.54006 12.5645 6.70301C11.7274 5.86595 10.3233 5.91995 9.51327 6.75701C8.70321 7.59407 8.70321 8.91716 9.54027 9.75422C10.0263 10.2403 10.7283 10.4563 11.4304 10.3213C11.2954 10.3483 11.1874 10.3483 11.0524 10.3483C10.9984 10.3483 10.9444 10.3483 10.8634 10.3483L11.8084 12.3734C10.9714 13.0214 10.1343 14.5605 10.1343 16.0457C10.1343 19.1779 12.4565 20.717 14.6706 20.717C15.9397 20.717 17.1548 20.2039 18.0189 19.2859L20.341 20.69C20.341 20.582 20.368 20.447 20.368 20.3389C20.341 20.474 20.341 20.582 20.341 20.717C20.341 21.8511 21.2591 22.7961 22.4202 22.7961C23.5812 22.7961 24.4993 21.8781 24.4993 20.717C24.4993 19.5559 23.5812 18.6378 22.4202 18.6378ZM11.4844 10.2943C11.5924 10.2673 11.7274 10.2403 11.8354 10.1862C11.7274 10.2403 11.6194 10.2943 11.4844 10.2943ZM12.4835 9.78122C12.4025 9.86222 12.3215 9.94323 12.2135 9.99723C12.2945 9.94323 12.4025 9.86222 12.4835 9.78122ZM12.1865 10.0242C12.0784 10.0782 11.9974 10.1322 11.8894 10.1862C11.9974 10.1322 12.0784 10.0782 12.1865 10.0242ZM14.6706 18.6378C13.2395 18.6378 12.0514 17.4768 12.0514 16.0457C12.0514 14.6146 13.2125 13.4265 14.6436 13.4265C16.0747 13.4265 17.2628 14.5876 17.2628 16.0187C17.2628 17.4497 16.1017 18.6108 14.6706 18.6378ZM21.2591 19.0159C21.1511 19.0969 21.0701 19.1779 20.9621 19.2589C21.0701 19.1509 21.1511 19.0699 21.2591 19.0159ZM20.503 19.9339C20.476 20.0419 20.422 20.1499 20.395 20.2579C20.449 20.1499 20.476 20.0419 20.503 19.9339ZM20.9621 19.2589C20.8811 19.3399 20.8 19.4209 20.746 19.5289C20.8 19.4209 20.8811 19.3399 20.9621 19.2589ZM20.692 19.5829C20.638 19.6909 20.557 19.7989 20.53 19.9069C20.584 19.7719 20.638 19.6639 20.692 19.5829Z"
                  fill="white"
                />
                <path
                  d="M8.80878 16.5586C8.80878 16.0186 8.51176 15.5595 8.16074 15.5865L6.40562 15.6135C5.83858 14.6955 4.65049 14.3985 3.73243 14.9385C2.81437 15.4785 2.51735 16.6936 3.05738 17.6117C3.59742 18.5297 4.81251 18.8268 5.73057 18.2867C6.02759 18.1247 6.2436 17.8817 6.40562 17.5847L8.18774 17.5577C8.51176 17.5577 8.80878 17.1256 8.80878 16.5586Z"
                  fill="white"
                />
              </svg>
              <span v-if="media.networks.length == 1">{{ $t('Available-in-network') }}</span>
              <span v-else>{{ $t('Available-in-networks', { num: media.networks.length }) }}</span>
            </a>
            <div class="d-lg-none d-xl-block d-xl-none mt-2"></div>
          </div>
        </div>
        <div v-if="inCollection" class="row">
          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-items-center fw-semibold p-0">
            <div v-if="media.presenters.length > 1" class="d-flex mt-2 align-items-center">
              <div class="mx-3">
                <div class="avatar-group avatar-group-overlapped mr-40 mt-25">
                  <div v-for="(p, i) in media.presenters.slice(0, 2)" :key="'presenter-' + i" class="avatar">
                    <img :src="p.image" :alt="p.name" class="avatar-img rounded-circle" />
                  </div>
                  <div v-if="media.presenters.length > 2" class="avatar">
                    <span class="avatar-text avatar-text-indigo rounded-circle">
                      <span class="initial-wrap">
                        <span>+{{ parseInt(media.presenters.length - 2) }}</span>
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              <div class="mx-3 text-start dropdown">
                <a
                  v-if="media.presenters.length > 0"
                  :id="'anchor'"
                  ref="anchor"
                  href="javascript:void(0)"
                  aria-describedby="tooltip"
                  class="dropbtn"
                  @click="visitMedia(media)"
                  @mouseenter="reinitilizePopper()"
                >
                  <span class="presenter-facepile-text">{{ $t('CardFull.presented-by') }}</span>
                  <span class="presenter-facepile-text">
                    <span v-for="(p, i) in media.presenters.slice(0, 3)" :key="'presenter-text-' + i" :class="i > 0 ? 'ms-1' : ''">
                      {{ p.name }}<span v-if="media.presenters.length-1 != i">, </span>
                    </span>
                  </span>
                  <span v-if="media.presenters.length > 3" class="presenter-facepile-text">
                    {{ $t('and-others', { num: parseInt(media.presenters.length - 3) }) }}
                  </span>
                </a>
                <ul :id="'anchordropdown'" ref="anchordropdown" class="list-group dropdown-content">
                  <li v-for="(p, i) in media.presenters.slice(0, media.presenters.length)" :key="'presenter-' + i" class="list-group-item">
                    <span class="pull-left ms">
                      <div :key="'presenter-' + i" class="avatar avatar-small">
                        <img :src="p.image" :alt="p.name" height="35" width="35" class="avatar-img rounded-circle" />
                      </div>
                    </span>
                    {{ p.name }}
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="media.presenters.length === 1" class="d-flex g-0 align-items-center" style="min-height: 42px;">
              <div class="mx-3">
                <div class="avatar-group avatar-group-overlapped mr-40 mt-25">
                  <div v-for="(p, i) in media.presenters.slice(0, 1)" :key="'presenter-' + i" class="avatar">
                    <img :src="p.image" :alt="p.name" class="avatar-img rounded-circle" />
                  </div>
                </div>
              </div>
              <div class="mx-3 text-start mt-1">
                <a v-for="(p, i) in media.presenters.slice(0, 1)" :key="'presenter-text-' + i" href="javascript:void(0)">
                  <p class="presenter-facepile-text">{{ $t('CardFull.presented-by') }} {{ p.name }}</p>
                </a>
              </div>
            </div>
            <div v-if="media.presenters.length === 0 && media.created_by" class="d-flex g-0 align-items-center" style="min-height: 42px;">
              <div class="mx-3">
                <div class="avatar-group avatar-group-overlapped mr-40 mt-25">
                  <div class="avatar">
                    <img :src="media.creator_img ? media.creator_img : '/img/user.png'" class="avatar-img rounded-circle" />
                  </div>
                </div>
              </div>
              <div class="mx-3 text-start mt-1">
                <p class="presenter-facepile-text">{{ $t('created-by') }} {{ media.created_by }}</p>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 p-0 d-flex justify-content-end">
            <div class="mx-2">
              <div v-if="media.tags && media.tags.length > 0">
                <button class="btn btn-outline-primary" style="height: 49px; border: 2px solid;" @click="showTagsModal = !showTagsModal">Tags</button>
              </div>
              <div v-else>
                <button class="btn text-secondary btn-sm m-2 fw-bold" style="background-color: #D9D9D9;">{{ $t('no-tags') }}</button>
              </div>
            </div>
            <div class="mx-2">
              <a class="btn btn-primary" style="padding-left: 16px;" @click="showBelongsToNetworkModal = !showBelongsToNetworkModal">
                <svg width="27" height="29" viewBox="3 1 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M24.1482 11.2933C25.2965 11.2933 26.2274 10.3624 26.2274 9.21415C26.2274 8.06587 25.2965 7.13501 24.1482 7.13501C23 7.13501 22.0691 8.06587 22.0691 9.21415C22.0691 10.3624 23 11.2933 24.1482 11.2933Z"
                    fill="white"
                  />
                  <path
                    d="M22.4202 18.6378C22.0151 18.6378 21.6371 18.7458 21.2861 18.9889C21.3401 18.9619 21.3671 18.9349 21.4211 18.9078L19.0989 17.5038C19.2609 17.0177 19.3419 16.5317 19.3419 16.0187C19.3419 15.3976 19.2069 14.7766 18.9639 14.2095L18.9369 14.1555L21.1241 12.6974C21.6101 12.3734 21.7451 11.7254 21.4481 11.2393V11.2123C21.1241 10.7263 20.476 10.5913 19.99 10.9153L17.6948 12.4544C16.8578 11.7524 15.8047 11.3473 14.7246 11.3473C14.4006 11.3473 14.0766 11.4013 13.7526 11.4823L12.8075 9.4572C12.7535 9.5382 12.6725 9.61921 12.5915 9.70021C13.4015 8.86316 13.4015 7.54006 12.5645 6.70301C11.7274 5.86595 10.3233 5.91995 9.51327 6.75701C8.70321 7.59407 8.70321 8.91716 9.54027 9.75422C10.0263 10.2403 10.7283 10.4563 11.4304 10.3213C11.2954 10.3483 11.1874 10.3483 11.0524 10.3483C10.9984 10.3483 10.9444 10.3483 10.8634 10.3483L11.8084 12.3734C10.9714 13.0214 10.1343 14.5605 10.1343 16.0457C10.1343 19.1779 12.4565 20.717 14.6706 20.717C15.9397 20.717 17.1548 20.2039 18.0189 19.2859L20.341 20.69C20.341 20.582 20.368 20.447 20.368 20.3389C20.341 20.474 20.341 20.582 20.341 20.717C20.341 21.8511 21.2591 22.7961 22.4202 22.7961C23.5812 22.7961 24.4993 21.8781 24.4993 20.717C24.4993 19.5559 23.5812 18.6378 22.4202 18.6378ZM11.4844 10.2943C11.5924 10.2673 11.7274 10.2403 11.8354 10.1862C11.7274 10.2403 11.6194 10.2943 11.4844 10.2943ZM12.4835 9.78122C12.4025 9.86222 12.3215 9.94323 12.2135 9.99723C12.2945 9.94323 12.4025 9.86222 12.4835 9.78122ZM12.1865 10.0242C12.0784 10.0782 11.9974 10.1322 11.8894 10.1862C11.9974 10.1322 12.0784 10.0782 12.1865 10.0242ZM14.6706 18.6378C13.2395 18.6378 12.0514 17.4768 12.0514 16.0457C12.0514 14.6146 13.2125 13.4265 14.6436 13.4265C16.0747 13.4265 17.2628 14.5876 17.2628 16.0187C17.2628 17.4497 16.1017 18.6108 14.6706 18.6378ZM21.2591 19.0159C21.1511 19.0969 21.0701 19.1779 20.9621 19.2589C21.0701 19.1509 21.1511 19.0699 21.2591 19.0159ZM20.503 19.9339C20.476 20.0419 20.422 20.1499 20.395 20.2579C20.449 20.1499 20.476 20.0419 20.503 19.9339ZM20.9621 19.2589C20.8811 19.3399 20.8 19.4209 20.746 19.5289C20.8 19.4209 20.8811 19.3399 20.9621 19.2589ZM20.692 19.5829C20.638 19.6909 20.557 19.7989 20.53 19.9069C20.584 19.7719 20.638 19.6639 20.692 19.5829Z"
                    fill="white"
                  />
                  <path
                    d="M8.80878 16.5586C8.80878 16.0186 8.51176 15.5595 8.16074 15.5865L6.40562 15.6135C5.83858 14.6955 4.65049 14.3985 3.73243 14.9385C2.81437 15.4785 2.51735 16.6936 3.05738 17.6117C3.59742 18.5297 4.81251 18.8268 5.73057 18.2867C6.02759 18.1247 6.2436 17.8817 6.40562 17.5847L8.18774 17.5577C8.51176 17.5577 8.80878 17.1256 8.80878 16.5586Z"
                    fill="white"
                  />
                </svg>
                <span v-if="media.networks.length == 1">{{ $t('Available-in-network') }}</span>
                <span v-else>{{ $t('Available-in-networks', { num: media.networks.length }) }}</span>
              </a>
              <div class="d-lg-none d-xl-block d-xl-none mt-2"></div>
            </div>
          </div>
        </div>
      </div>
      <hr v-if="media.attachments.length > 0 && !inCourse" />
      <div v-if="media.attachments.length > 0 && !inCourse" class="col-12">
        <div class="card p-3" @click="toggleIcon = !toggleIcon">
          <a data-bs-toggle="collapse" data-bs-target="#collapseExample" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample"
          style="display: flex; justify-content: space-between; font-weight: 600; text-decoration: none;">
            <span class="text-secondary">{{ $t('network.message.attachedMedia') }}</span>
            <i :class="toggleIcon ? 'fas fa-chevron-circle-up mt-1' : 'fas fa-chevron-circle-down mt-1'"></i>
          </a>
          <div>
            <div v-for="(attachment, index) in media.attachments" id="collapseExample" :key="index" class="form collapse"><hr />
              <div class="mt-2 fw-bold" style="display: flex; justify-content: space-between;">
                <span>{{ attachment.title }}</span>
                <span class="text-primary" style="cursor: pointer;" @click="downloadAttachment(attachment)">
                  {{ $t('network.download') }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-modal v-model="showBelongsToNetworkModal" hide-footer hide-header size="lg">
        <BelongsToNetwork :networksList="media.networks" @belongsToNetworkSuccess="showBelongsToNetworkModal = false" @close="showBelongsToNetworkModal = false" />
      </b-modal>
      <Modal :show.sync="showTagsModal">
        <div v-if="inCollection" class="row">
          <div class="col-12">
            <ul class="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-1 fs-6">
              <li class="nav-item">
                <a class="nav-link active fw-semibold text-dark" data-bs-toggle="tab" href="#media_tab">
                  Media tags
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link fw-semibold text-dark" data-bs-toggle="tab" href="#collection_tab">
                  Collection tags
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div id="myTabContent" class="tab-content">
              <div id="media_tab" class="tab-pane fade show active" role="tabpanel">
                <div class="row mb-2" :class="inCollection ? 'mt-3' : 'mt-2'">
                  <div v-if="media.tags" class="col-lg-12 col-md-12 col-sm-12 col-xs-12 align-items-center">
                    <span v-for="tag in sortedArray(media.tags)" :key="tag.id">
                      <span class="badge m-2 media-badge">#{{ tag.name }}</span>
                    </span>
                  </div>
                </div>
              </div>
              <div v-if="inCollection" id="collection_tab" class="tab-pane fade" role="tabpanel">
                <div class="row mt-3 mb-2">
                  <div v-if="collection && collection.tags" class="col-lg-12 col-md-12 col-sm-12 col-xs-12 align-items-center">
                    <span v-for="tag in sortedArray(collection.tags)" :key="tag.id">
                      <span class="badge m-2 media-badge">#{{ tag.name }}</span>
                    </span>
                  </div>
                  <div v-else class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-2 align-items-center">
                    <span>This collection doesn't have any tags.</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <Modal :show.sync="showViewsModal">
        <div class="row">
          <div class="col-12">
            <ul class="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-1 fs-6">
              <li class="nav-item">
                <a class="nav-link active fw-semibold text-dark" data-bs-toggle="tab" href="#all_tab">
                  All users
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link fw-semibold text-dark" data-bs-toggle="tab" href="#logged_tab">
                  Logged in users
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link fw-semibold text-dark" data-bs-toggle="tab" href="#unlogged_tab">
                  Logged out users
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div id="myTabContent" class="tab-content">
              <div id="all_tab" class="tab-pane fade show active" role="tabpanel">
                <div class="row mt-3 mb-n3">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 align-items-center">
                    <p>Views: {{ stats.all_users.views }}</p>
                    <p v-if="media.type != 'video'">Downloads: {{ stats.all_users.downloads }}</p>
                    <p>Likes: {{ stats.all_users.likes }}</p>
                    <p v-if="media.type === 'video'">Plays: {{ stats.all_users.plays }}</p>
                    <p v-if="media.type === 'video'">Completed plays: {{ stats.all_users.completed_plays }}</p>
                  </div>
                </div>
              </div>
              <div id="logged_tab" class="tab-pane fade" role="tabpanel">
                <div class="row mt-3 mb-n3">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 align-items-center">
                    <p>Views: {{ stats.logged_users.views }}</p>
                    <p v-if="media.type != 'video'">Downloads: {{ stats.logged_users.downloads }}</p>
                    <p v-if="media.type === 'video'">Plays: {{ stats.logged_users.plays }}</p>
                    <p v-if="media.type === 'video'">Completed plays: {{ stats.logged_users.completed_plays }}</p>
                    <p>Likes: {{ stats.logged_users.likes }}</p>
                  </div>
                </div>
              </div>
              <div id="unlogged_tab" class="tab-pane fade" role="tabpanel">
                <div class="row mt-3 mb-n3">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 align-items-center">
                    <p>Views: {{ stats.unlogged_users.views }}</p>
                    <p v-if="media.type != 'video'">Downloads: {{ stats.unlogged_users.downloads }}</p>
                    <p v-if="media.type === 'video'">Plays: {{ stats.unlogged_users.plays }}</p>
                    <p v-if="media.type === 'video'">Completed plays: {{ stats.unlogged_users.completed_plays }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
    <div v-if="busy" class="text-center" style="padding-top: 11rem;">
      <i class="fas fa-5x fa-spinner"></i>
    </div>
  </div>
</template>
<script>
const BelongsToNetwork = () => import('@/views/networks/media/BelongsToNetwork.vue');
const PDFJSViewer = () => import('./PDFJSViewer.vue');
import Modal from '@/components/commons/Modals/Modal.vue';
import InlineSvg from 'vue-inline-svg';
import Vimeo from '@vimeo/player';
import sortBy from 'lodash/sortBy';

export default {
  components: {
    BelongsToNetwork,
    PDFJSViewer,
    InlineSvg,
    Modal,
  },
  props: {
    media: {
      type: Object,
      default: null,
    },
    inCollection: {
      type: Boolean,
      default: false,
    },
    collection: {
      type: Object,
      default: null,
    },
    inCourse: {
      type: Boolean,
      default: false,
    },
    media_slug: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      busy: false,
      name: '/test.pdf', //change which pdf file loads
      path: '/lib/pdfjs-2.13.216-dist/web/viewer.html', //path of the PDF.js viewer.html
      showBelongsToNetworkModal: false,
      showTagsModal: false,
      showViewsModal: false,
      toggleIcon: false,
      maxPosition: 0,
      stats: {
        all_users: { views: 0, downloads: 0, likes: 0, plays: 0, completed_plays: 0 },
        logged_users: { views: 0, downloads: 0, plays: 0, completed_plays: 0, likes: 0 },
        unlogged_users: { views: 0, downloads: 0, plays: 0, completed_plays: 0 },
      },
    };
  },
  computed: {
    isImageFile() {
      return this.isFileType(['png', 'jpg', 'jpeg', 'gif']);
    },
    mediaPreviewSupported() {
      return this.isFileType(['png', 'jpg', 'jpeg', 'gif', 'pdf', 'svg']) || this.media.type === 'video';
    },
  },
  watch: {
    media_slug(newSlug) {
      this.loadMedia(newSlug);
    },
  },
  mounted() {
    if (this.inCourse && this.media_slug) {
      this.loadMedia(this.media_slug);
    }
    if (this.media.type === 'video') {
      // Initialize the Vimeo Player
      const player = new Vimeo(this.$refs.vimeoPlayer, {
        id: this.media.vimeo_number,
        autoplay: true,
      });

      // Event listeners
      player.on('play', () => {
        this.$http.post('log-activity/' + this.media.slug, { action : 'play' });
      });

      player.on('timeupdate', ({ seconds }) => {
        if (seconds > this.maxPosition) {
          this.maxPosition = seconds.toFixed(2);
        }
      });

      player.on('pause', () => {
        // Calculate the percentage watched
        const percentage = ((this.maxPosition / this.media.duration_seconds) * 100).toFixed(2);

        if (percentage < 100) {
          this.$http.post('log-activity/' + this.media.slug, { action : 'pause', 'position_reached': this.maxPosition, 'percentage_watched': percentage });
        }
      });

      player.on('ended', () => {
        this.$http.post('log-activity/' + this.media.slug, { action : 'play_complete' });
      });
    }
    this.$http.get('networks/media/' + this.media.id + '/stats').then(resp => {
      this.busy = true;
      this.stats = resp.data.data;
    }).then(() => {
      this.busy = false;
    });
  },
  methods: {
    loadMedia(slug) {
      this.busy = true;
      this.$http.get('networks/media/' + slug).then(resp => {
        this.media = resp.data;
      }).then(() => {
        this.busy = false;
      });
    },
    downloadAttachment(attachment) {
      this.$http.post('log-activity/' + this.media.slug, { attachment: attachment, action : 'download' }).then(() => {
        var link = document.createElement('a');
        link.setAttribute('download', attachment.title);
        link.href = attachment.path_url;
        document.body.appendChild(link);
        link.click();
        link.remove();
      });
    },
    sortedArray(array) {
      return sortBy(array, item => item.name.toLowerCase());
    },
    isFileType(supportedExtensions) {
      const fileExtension = this.media.file_extension.toLowerCase();
      return this.media.type === 'file' && supportedExtensions.map(ext => ext.toLowerCase()).includes(fileExtension);
    },
    downloadMedia() {
      this.$http.post('log-activity/' + this.media.slug, { action : 'download' }).then(() => {
        window.location.href = this.media.url.download;
      });
    },
  },
};
</script>
<style scoped>
.lead {
  font-size: 1.25rem;
}
.nav-line-tabs.nav-line-tabs-2x {
  border-bottom-width: 2px;
}
.nav-line-tabs {
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: #eff2f5;
}
.nav-line-tabs.nav-line-tabs-2x .nav-item {
  margin-bottom: -2px;
}
.nav-line-tabs .nav-item {
  margin-bottom: -1px;
}
.nav-line-tabs.nav-line-tabs-2x .nav-item .nav-link.active, .nav-line-tabs.nav-line-tabs-2x .nav-item.show
.nav-link, .nav-line-tabs.nav-line-tabs-2x .nav-item .nav-link:hover:not(.disabled) {
  border-bottom-width: 2px;
}
html a:hover, html a:active, html a:focus, body a:hover, body a:active, body a:focus {
  text-decoration: none !important;
}
.nav-line-tabs .nav-item .nav-link.active, .nav-line-tabs .nav-item.show
.nav-link, .nav-line-tabs .nav-item .nav-link:hover:not(.disabled) {
  background-color: transparent;
  border: 0;
  border-bottom: 1px solid #005f9a;
  transition: color .2s ease, background-color .2s ease;
  text-decoration: none !important;
}
.nav-line-tabs .nav-item .nav-link {
  color: #a1a5b7;
  border: 0;
  border-bottom: 1px solid transparent;
  border-radius: inherit;
  transition: color .2s ease, background-color .2s ease;
  padding: 0.5rem 0;
  margin: 0 1rem;
}
.nav-link:hover, .nav-link:focus {
  color: #00304e;
  text-decoration: none;
}
</style>
